exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".funeral-index-wrapper[data-v-644ee444]{display:flex;flex-grow:1}", ""]);

// exports
